var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("size-tables-title")))]),
      _c(
        "w-list",
        [
          _vm._l(_vm.sizeTables, function (table) {
            return _c(
              "w-list-item",
              { key: table.ID },
              [
                _c("w-list-item-text", [
                  _vm._v(" " + _vm._s(table.Name) + " "),
                  !table.Active
                    ? _c("span", { staticClass: "muted" }, [
                        _vm._v(
                          "(" + _vm._s(_vm.$ct("size-table-inactive")) + ")"
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("w-list-item-text", [
                  _vm._v(
                    " " +
                      _vm._s(table.Entries.length) +
                      " " +
                      _vm._s(_vm.$ct("sizes")) +
                      " "
                  ),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t("common.edit"),
                            expression: "$t('common.edit')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editTable(table)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t("common.delete"),
                            expression: "$t('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteTable(table)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.addTable()
                },
              },
            },
            [
              _c("w-list-item-text", [
                _c(
                  "span",
                  [
                    _c("w-fa", { attrs: { icon: "plus" } }),
                    _vm._v(" " + _vm._s(_vm.$t("common.add"))),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEdit != null } },
        [
          _vm.toEdit
            ? _c(
                "w-card",
                { attrs: { "max-width": "600" } },
                [
                  _c("w-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.toEdit.ID
                          ? _vm.$ct("edit-size-table")
                          : _vm.$ct("new-size-table")
                      )
                    ),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "8" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("size-table-name"),
                                },
                                model: {
                                  value: _vm.toEdit.Name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.toEdit, "Name", $$v)
                                  },
                                  expression: "toEdit.Name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-checkbox", {
                                attrs: { label: _vm.$ct("active") },
                                model: {
                                  value: _vm.toEdit.Active,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.toEdit, "Active", $$v)
                                  },
                                  expression: "toEdit.Active",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "label mt" }, [
                        _vm._v(_vm._s(_vm.$ct("sizes"))),
                      ]),
                      _c(
                        "w-scroll-view",
                        { style: { maxHeight: "45vh" } },
                        [
                          _c(
                            "w-sortable",
                            {
                              attrs: {
                                tag: "w-list",
                                items: _vm.toEdit.Entries,
                                "keep-in-y": "",
                                "target-class": "handle",
                              },
                              on: {
                                drop: function ($event) {
                                  return _vm.onSorted()
                                },
                              },
                            },
                            _vm._l(_vm.toEdit.Entries, function (entry) {
                              return _c(
                                "w-list-item",
                                {
                                  key: entry.clientKey,
                                  attrs: { "show-handle": "" },
                                },
                                [
                                  _c(
                                    "w-list-item-text",
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("size-name"),
                                        },
                                        model: {
                                          value: entry.Name,
                                          callback: function ($$v) {
                                            _vm.$set(entry, "Name", $$v)
                                          },
                                          expression: "entry.Name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-list-item-action",
                                    [
                                      _c(
                                        "w-button",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.$t("common.delete"),
                                              expression: "$t('common.delete')",
                                            },
                                          ],
                                          staticClass: "danger",
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeEntry(entry)
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "trash" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list",
                        [
                          _c(
                            "w-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.addEntry()
                                },
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _c(
                                  "span",
                                  [
                                    _c("w-fa", { attrs: { icon: "plus" } }),
                                    _vm._v(" " + _vm._s(_vm.$ct("add-size"))),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: {
                            disabled: !_vm.saveEnabled,
                            loading: _vm.saving,
                            icon: "save",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveTable()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }